import { Method } from "../../enums/enums"
import { OfficelyRoutes, ResponseOfficely, useFetchOfficely } from "../../hooks/use-fetch-officely"
import { Chat } from "../../pages/web-channel/interfaces"
import { Agent } from "../../redux/agents"



// export async function IngestAgent(agent: Agent, typeData: DataSourceType, token: string, agentImg:File | string |null, file?:File): Promise<ResponseOfficely> {
//     const formData = new FormData();
//     formData.append('agent', JSON.stringify(agent));
//     formData.append('typeData', typeData);
//     agentImg && formData.append('agentImg', agentImg);
//     file && formData.append('file', file);
//     return await useFetchOfficely(OfficelyRoutes.INGEST_AGENT, Method.POST, formData, token)
// }

export async function RunAgent(body:any): Promise<Array<Chat> | boolean> {
    const res = await useFetchOfficely(OfficelyRoutes.RUN_AGENT, Method.POST, body)
    if (res.success && res.data) {
        return res.data as Array<Chat>
    }
    return false
}

export async function DeleteAgent(agent_id:string, token:string): Promise<Array<Chat> | boolean> {
    const res = await useFetchOfficely(`${OfficelyRoutes.DELETE_AGENT}/${agent_id}`, Method.POST, null, token)
    return res.success
}

export async function IngestAgent(agent: Agent, token:string): Promise<ResponseOfficely> {
    return await useFetchOfficely(OfficelyRoutes.INGEST_AGENT, Method.POST, agent, token)
}

export async function GetAgentDeatilsByID(id:string): Promise<ResponseOfficely> {
    return await useFetchOfficely(`${OfficelyRoutes.GET_AGENT_DEATILS}/${id}`, Method.GET, null)
}

export async function RunAssistantAgent(body:any):Promise<Array<Chat> | boolean> {
    const res =  await useFetchOfficely(OfficelyRoutes.AI_CHAT, Method.POST, body)
    if (res.success && res.data) {
        return res.data as Array<Chat>
    }
    return false
}

